import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard-live-connection-help-dialog',
  templateUrl: './dashboard-live-connection-help-dialog.component.html',
  styleUrls: ['./dashboard-live-connection-help-dialog.component.scss']
})
export class DashboardLiveConnectionHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<DashboardLiveConnectionHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


